export default Vue => {
  Vue.component("v-modal", () => import("./v-modal.vue"));
};
